<template>
  <div class="kathong-container w-100">
    <div class="kathong" :class="speed">
      <p class="text-white wish">
        {{ wish }}
      </p>
      <img :src="src" :class="size" />
      <p class="text-white name">{{ string }}</p>
      <!-- <b-img
          style="margin-top:20px;"
          src="../assets/zodiacbtn.png"
          @click="subMit"
        /> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    wish: String,
    name: String,
    src: String,
    size: String,
    speed: String,
  },
  mounted() {
    console.log(this.src);
  },
};
</script>

<style lang="scss" scoped>
.kathong-container {
  position: relative;
  height: 50px;
}

.kathong {
  bottom: 15%;
  position: absolute;
  -webkit-animation: linear infinite;
  -webkit-animation-name: run;
  // padding: 20px 0;
}

.wish {
  /* display: none; */
  position: absolute;
  top: 0px;
  left: 60%;
  word-break: break-all;
  width: 200px;
  text-align: left;
}
.big {
  // width: 120px;
  height: 7vh;
}

.medium {
  // width: 80px;
  height: 7vh;
}

.small {
  // width: 60px;
  height: 7vh;
}

.almost_fast {
  -webkit-animation-duration: 12s;
}
.fast {
  -webkit-animation-duration: 10s;
}

.faster {
  -webkit-animation-duration: 7s;
}

.fastest {
  -webkit-animation-duration: 5s;
}
@-webkit-keyframes run {
  0% {
    left: -30%;
  }
  100% {
    left: 100%;
  }
}

@media only screen and (min-height: 700px) {
  .kathong-container {
    position: relative;
    height: 90px;
  }
}
</style>
